import React, { useEffect, useRef } from 'react';
import { Col, Card, Row } from "react-bootstrap";
import BloodGroupPieChart from "./BloodGroupStatisticsChart";
import { useDonor } from '../../../../../context/donor/donor.context';
import { useTranslation } from "react-i18next";
const BloodGroupStatisticsChart = () => {
    const { bloodGroupStatistics, fetchBloodGroupStatistics, loading } = useDonor();
    const hasFetchedRef = useRef(false);

    const { t } = useTranslation();
    useEffect(() => {
        if (!hasFetchedRef.current) {
            fetchBloodGroupStatistics();
            hasFetchedRef.current = true;
        }
    }, [fetchBloodGroupStatistics]);

    const handleRefresh = () => {
        fetchBloodGroupStatistics();
    };

    return (
        <Col xl={6} lg={6}>
            <Card>
                <Card.Header className="d-flex justify-content-between align-items-center">
                    <Card.Title>{t("bloodGroupDistribution")}</Card.Title>
                    <button 
                        className="btn btn-sm btn-primary" 
                        onClick={handleRefresh}
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-1" role="status"></span>
                                {t("Loading")}...
                            </>
                        ) : (
                            <>
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    width="16" 
                                    height="16" 
                                    fill="currentColor" 
                                    className="me-1" 
                                    viewBox="0 0 16 16"
                                >
                                    <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                                    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                                </svg>
                            </>
                        )}
                    </button>
                </Card.Header>

                <Card.Body style={{ minHeight: '500px' }}>
                    {loading && !bloodGroupStatistics ? (
                        <div className="text-center py-5">
                            <div className="spinner-border" role="status">
                                <span className="sr-only">{t("Loading")}...</span>
                            </div>
                            <p className="mt-2">{t("Loading")}...</p>
                        </div>
                    ) : bloodGroupStatistics && bloodGroupStatistics.total > 0 ? (
                        <>
                            <div style={{ height: '350px', width: '100%' }}>
                                <BloodGroupPieChart bloodGroupStatistics={bloodGroupStatistics} />
                            </div>

                            <div className="mt-4">
                                <h5 className="text-center mb-3">
                                    <strong>{t("donors.totalUnits")}</strong> {bloodGroupStatistics.total}
                                </h5>

                                <Row>
                                    {[
                                        { label: "A+", value: bloodGroupStatistics.aPlus, color: "text-danger" },
                                        { label: "A-", value: bloodGroupStatistics.aMinus, color: "text-info" },
                                        { label: "B+", value: bloodGroupStatistics.bPlus, color: "text-warning" },
                                        { label: "B-", value: bloodGroupStatistics.bMinus, color: "text-success" },
                                        { label: "AB+", value: bloodGroupStatistics.abPlus, color: "text-primary" },
                                        { label: "AB-", value: bloodGroupStatistics.abMinus, color: "text-secondary" },
                                        { label: "O+", value: bloodGroupStatistics.oPlus, color: "text-danger" },
                                        { label: "O-", value: bloodGroupStatistics.oMinus, color: "text-dark" }
                                    ].map(({ label, value, color }) => (
                                        <Col xs={6} md={3} className="mb-2 text-center" key={label}>
                                            <div className="p-2 border rounded">
                                                <strong className={color}>{label}</strong>
                                                <br />
                                                <span>{value}</span>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>
                        </>
                    ) : (
                        <div className="text-center py-5">
                            <p>No blood units available in store</p>
                        </div>
                    )}
                </Card.Body>
            </Card>
        </Col>
    );
};

export default BloodGroupStatisticsChart;
